import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatMessageListUtilityClass(slot) {
  return generateUtilityClass('MuiChatMessageList', slot);
}
export const chatMessageListClasses = generateUtilityClasses('MuiChatMessageList', ['root', 'scroller', 'content']);
const slots = {
  root: ['root'],
  scroller: ['scroller'],
  content: ['content']
};
export const useChatMessageListUtilityClasses = classes => composeClasses(slots, getChatMessageListUtilityClass, classes);